import { render, staticRenderFns } from "./cursos_estudiante.vue?vue&type=template&id=ad787694"
import script from "./cursos_estudiante.vue?vue&type=script&lang=js"
export * from "./cursos_estudiante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports